<template>
  <div>
    <div class="panel mt-20">
      <div class="header">
        <h2>概览</h2>
      </div>
      <ul
        class="flex-row-between overview"
        v-if="customer && customer.order_overview"
      >
        <!-- <li class="sub-info">
          <span class="sub-info-label">报价单总数</span>
          <span class="sub-info-value text-primary">
            {{ customer.order_overview.quotation_count }}
          </span>
        </li> -->

        <li class="sub-info">
          <span class="sub-info-label">报价单总数</span>
          <span class="sub-info-value text-primary">
            {{ customer.order_overview.order_count }}
          </span>
        </li>
        <!-- <li class="sub-info">
          <span class="sub-info-label">订单总金额</span>
          <span class="sub-info-value text-primary"
            >￥{{ customer.order_overview.total_amount.toFixed(2) }}</span
          >
        </li> -->
        <li class="sub-info">
          <span class="sub-info-label">剩余回款</span>
          <span class="sub-info-value text-danger">
            ￥{{
              Math.max(
                customer.order_overview.total_amount -
                  customer.order_overview.collection_amount,
                0
              ).toFixed(2)
            }}
          </span>
        </li>
        <li class="sub-info" v-if="!isMobile()">
          <span class="sub-info-label">总费用</span>
          <span class="sub-info-value text-primary"
            >￥{{ customer.order_overview.cost_amount }}</span
          >
        </li>
      </ul>
    </div>
    <div class="panel mt-20" v-permission="Auth.customerContactorList">
      <div class="header flex-row-between">
        <h2>客户联系人</h2>
        <el-button
          v-if="!customer.deleted"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="startCustomerContactFormer()"
          v-permission="Auth.customerContactorNew"
          >添加联系人</el-button
        >
      </div>
      <el-table v-if="!isMobile()" :data="contacts" stripe key="contacts">
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="mobile" label="电话"></el-table-column>
        <el-table-column prop="duty" label="职务"></el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
        <el-table-column label="操作" width="140" v-if="!customer.deleted">
          <template slot-scope="scope">
            <div class="flex-row-between">
              <el-button
                type="danger"
                size="mini"
                plain
                v-permission="Auth.customerContactorDelete"
                >删除</el-button
              >
              <el-button
                type="primary"
                size="mini"
                plain
                @click="startCustomerContactFormer(scope.row, scope.$index)"
                v-permission="Auth.customerContactorEdit"
                >修改</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li
          v-for="(item, index) in contacts"
          :key="item.id"
          class="flex-row-between"
        >
          <div>
            <div>
              {{ item.name }}
              <span
                v-if="item.duty && item.duty.length > 0"
                class="text-info-12"
                >({{ item.duty }})</span
              >
            </div>
            <div class="mt-10" v-if="item.mobile && item.mobile.length > 0">
              <a :href="'tel:' + item.mobile">{{ item.mobile }}</a>
            </div>
            <div v-if="item.email && item.email.length > 0">
              <a :href="'mailto:' + item.email">{{ item.email }}</a>
            </div>
          </div>
          <div style="width: 122px">
            <el-button
              type="danger"
              size="mini"
              plain
              v-permission="Auth.customerContactorDelete"
              >删除</el-button
            >
            <el-button
              type="primary"
              size="mini"
              plain
              @click="startCustomerContactFormer(item, index)"
              v-permission="Auth.customerContactorEdit"
              >修改</el-button
            >
          </div>
        </li>
      </ul>
    </div>
    <customer-contact-former
      :model="customerContactForm"
      :show.sync="createCustomerContactFormVisible"
      @created="createdCustomerContact"
      @updated="updatedCustomerContact"
    ></customer-contact-former>
  </div>
</template>

<script>
import {
  creatCustomerContact,
  customerContactList,
  deleteCustomerContact,
} from '../../service/getData'
import CustomerContactFormer from '@/components/customer_contact'
import { formatTime, isMobile } from '@/util/index'

import { clone } from '@/util'

export default {
  props: {
    customer: {
      type: Object,
    },
    customerID: {
      type: Number,
    },
  },
  components: { CustomerContactFormer },
  data() {
    return {
      isMobile,
      formatTime,
      contacts: [],
      customerContactForm: {},
      editContactIndex: 0,
      createCustomerContactFormVisible: false,
    }
  },
  created() {
    this.requestCustomerContactList()
  },
  methods: {
    startCustomerContactFormer(contact, index) {
      if (contact) {
        this.customerContactForm = clone(contact)
        this.editContactIndex = index
      } else {
        this.customerContactForm = {
          customer_id: this.customerID,
          name: '',
          duty: '',
          mobile: '',
          email: '',
        }
      }
      this.createCustomerContactFormVisible = true
    },
    async requestCustomerContactList() {
      let res = await customerContactList({
        customer_id: this.customerID,
      })
      this.contacts = res.data.list
    },
    updatedCustomerContact(contact) {
      this.contacts.splice(this.editContactIndex, 1, contact)
      this.requestCustomerLogList()
    },
    createdCustomerContact(contact) {
      this.contacts.unshift(contact)
    },
    deleteContact(index) {
      let c = this.contacts[index]
      let that = this
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteCustomerContact(c.id).then((res) => {
          if (res.code == 0) {
            that.contacts.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>